export default [
  {
    title: "Collect Point By Counter",
    customIcon: "CustomSVG",
    children: [
      {
        title: "Collect Point By Counter",
        route: "custom-collect-point-by-counter-adjust-receipt",
        path: "/custom-collect-point-by-counter/adjust-receipt",
      },
    ],
  },
];
